import { put } from "redux-saga/effects";
import importer from "common/importer";
const ChatbotActions = importer("Stores/Chatbot/Actions");
const PublicContentActions = importer("Stores/PublicContent/Actions");
import { getMinStaticContent } from "@takedapdt/biolife-cms-kit";
import i18next from "i18next";

export default function* main({ slug }) {
  try {
    yield put(PublicContentActions.getLocationsPageLoading());
    const data = (yield getMinStaticContent("location_pages", {
      lang: i18next.language,
      filters: { field_slug_value: slug },
    }))[0];
    const showChatbotData = data?.metadata;
    yield put(
      ChatbotActions.setChatbotForPageView(
        showChatbotData.hasOwnProperty("field_chatbot"),
        !!showChatbotData["field_chatbot"]
      )
    );
    yield put(ChatbotActions.showHideChatbot(true));
    yield put(PublicContentActions.getLocationsPageSuccess(data));
  } catch (error) {
    yield put(PublicContentActions.getLocationsPageFailure(error));
  }
}
